import { TApi } from 'utils/api';

export type TSetBasketParams = {
  products: Array<{ id: string; quantity: number }>;
  regionCode?: string;
  api: TApi;
};

export function setBasket({ products, regionCode, api }: TSetBasketParams) {
  return api.put('set-basket', {
    products,
    regionCode,
  });
}
